import { Button, Input, Modal, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { getUserId } from '../../../helpers/auth'
import CustomersDropdown from '../../CustomersDropdown'
import { toast } from 'react-toastify'
import CampaignDropdown from '../../CampaignDropdown'
import Loader from '../../../pages/pages/loader'
import { useCreateCampaignAdvancedKeywordMutation } from '../../../redux/apis/campaignsManagement/advancedKeywords/cMAdvancedKeywordsApiSlice'
import LanguageDropdown from '../../LanguageDropdown'

const AddSearchEngineKeywordModal = () => {
  const [open, setOpen] = useState(false)
    const [create, { isLoading, error, isSuccess }] =
    useCreateCampaignAdvancedKeywordMutation()

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      campaign: null,
      campaign_advanced_keyword: '',
      language: '',
      keyword_status: true,
      // last_updated_by: getUserId()
    },

    validationSchema: Yup.object({
      campaign: Yup.number().required('Please Select Campaign Name'),
      campaign_advanced_keyword: Yup.string().required('Please Enter Campaign Key word'),
      language: Yup.number().required('Please Enter Campaign Language'),
      keyword_status: Yup.boolean().required('Please Select Campaign Status')
    }),

    onSubmit: async values => {
      try {
        await create(values)
      } catch (error) {
        console.error(error)
      }
    }
  })

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  useEffect(() => {
    if (isSuccess) {
      toast.success('Campaign Keyword Added!')
      setOpen(false)
      validation.resetForm()
    }
  }, [isSuccess])
  return (
    <>
      <Loader isLoading={isLoading} />
      <div className='flex w-full justify-end'>
        <button
          className='btn btn-outline-theme mb-4'
          onClick={() => {
            setOpen(true)
          }}
        >
          Create New Campaign Advanced Keyword
        </button>
      </div>
      <Modal
        open={open}
        title='Create Campaign Keyword'
        onCancel={() => setOpen(false)}
        footer={[
          <Button key='back' onClick={() => setOpen(false)}>
            Cancel
          </Button>,
          <Button
            key='submit'
            type='primary'
            onClick={() => {
              if (Object.keys(validation.errors).length !== 0) {
                Object.keys(validation.errors).map(key => {
                  toast.error(validation.errors[key])
                })
                return
              }
              validation.handleSubmit()
            }}
          >
            Submit
          </Button>
        ]}
      >
        <div className='gap-8 '>
          <div className=' mb-3 flex-1'>
            <label className="form-label">Campaign Advanced Keyword</label>
            <Input
              type='text'
              name='campaign_advanced_keyword'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.campaign_advanced_keyword}
            />
            {validation.touched.campaign_advanced_keyword &&
            validation.errors.campaign_advanced_keyword ? (
              <p className='text-danger'>
                {validation.errors.campaign_advanced_keyword}
              </p>
            ) : null}
          </div>
          <CampaignDropdown
            onBlur={validation.handleBlur}
            onChange={e => {
              validation.setFieldValue('campaign', e)
            }}
            value={validation.values?.campaign}
          />
          {validation.touched.campaign && validation.errors.campaign ? (
            <p className='text-danger'>{validation.errors.campaign}</p>
          ) : null}
          <LanguageDropdown
            onBlur={validation.handleBlur}
            onChange={e => {
              validation.setFieldValue('language', e)
            }}
            value={validation.values?.language}
          />
          {validation.touched.language && validation.errors.language ? (
            <p className='text-danger'>{validation.errors.language}</p>
          ) : null}

          <div className=' mb-3 flex-1'>
            <label>Campaign keyword Status</label>
            <br />
            <Select
              className={''}
              name='keyword_status'
              style={{
                width: '100%'
              }}
              defaultValue={validation?.values?.keyword_status}
              value={validation?.values?.keyword_status}
              onChange={e => validation.setFieldValue('keyword_status', e)}
              onBlur={validation.handleBlur}
              options={[
                {
                  label: 'Active',
                  value: true
                },
                {
                  label: 'Inactive',
                  value: false
                }
              ]}
            />
            {validation.touched.keyword_status && validation.errors.keyword_status ? (
              <p className='text-danger'>{validation.errors.keyword_status}</p>
            ) : null}
          </div>
        </div>
      </Modal>
    </>
  )
}

export default AddSearchEngineKeywordModal
